<template>
    <i :class="[icon, 'loading-spinner']"></i>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "LoadingSpinner",
    props: {
        icon: {
            type: String,
            default: "fa fa-spinner",
        },
    },
});
</script>

<style scoped>
@import "@/style/components/loading.css";
</style>
